function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { translate } from '../utils/helpers';
import PropTypes from 'prop-types';

var Tab = /*#__PURE__*/function (_Component) {
  _inherits(Tab, _Component);

  var _super = _createSuper(Tab);

  function Tab() {
    var _this;

    _classCallCheck(this, Tab);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e) {
      e.preventDefault();

      _this.props.handleClick();
    });

    return _this;
  }

  _createClass(Tab, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("span", {
        className: "-headertitle main-txt-hover ".concat(this.props.isCurrent ? 'active main-txt' : null),
        onClick: this.handleClick
      }, this.props.name.toUpperCase());
    }
  }]);

  return Tab;
}(Component);

var Tabs = /*#__PURE__*/function (_Component2) {
  _inherits(Tabs, _Component2);

  var _super2 = _createSuper(Tabs);

  function Tabs(props) {
    var _this2;

    _classCallCheck(this, Tabs);

    _this2 = _super2.call(this, props);

    _defineProperty(_assertThisInitialized(_this2), "handleClick", function (tab) {
      _this2.props.changeTab(tab);
    });

    _this2.state = {
      tabList: _this2.props.tabList
    };
    return _this2;
  }

  _createClass(Tabs, [{
    key: "render",
    value: function render() {
      var _this3 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, this.state.tabList.map(function (tab) {
        return /*#__PURE__*/React.createElement(Tab, {
          key: tab.id,
          handleClick: _this3.handleClick.bind(_this3, tab),
          name: tab.name,
          isCurrent: _this3.props.currentTab === tab.id
        });
      }), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "close",
        "data-dismiss": "modal",
        "aria-label": "Close"
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7")));
    }
  }]);

  return Tabs;
}(Component);

var Content = /*#__PURE__*/function (_Component3) {
  _inherits(Content, _Component3);

  var _super3 = _createSuper(Content);

  function Content() {
    var _this4;

    _classCallCheck(this, Content);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this4 = _super3.call.apply(_super3, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this4), "CalcCirc", function () {
      var trashDiameter = parseFloat($('#circ_diameter').val());
      var trashHeight = parseFloat($('#circ_height').val());

      if (isNaN(trashDiameter) || isNaN(trashHeight)) {
        $('#circ_result').val(translate('Unknown', 'Inconnue'));
      } else {
        var overhang = 4;
        var bagWidth = Math.ceil(trashDiameter * 1.57083);
        var bagHeight = Math.ceil(trashDiameter / 2 + trashHeight + overhang);
        $('#circ_result').val(bagWidth + ' x ' + bagHeight);
      }
    });

    _defineProperty(_assertThisInitialized(_this4), "CalcRect", function () {
      var side1Width = parseFloat($('#rect_width_side_1').val());
      var side2Width = parseFloat($('#rect_width_side_2').val());
      var trashHeight = parseFloat($('#rect_height').val());

      if (isNaN(side1Width) || isNaN(side2Width) || isNaN(trashHeight)) {
        $('#rect_result').val(translate('Unknown', 'Inconnue'));
      } else {
        var overhang = 4;
        var bagWidth = side1Width + side2Width;
        var smallestSide = side2Width;

        if (side1Width < side2Width) {
          smallestSide = side1Width;
        }

        var bagHeight = Math.ceil(smallestSide / 2 + trashHeight + overhang);
        $('#rect_result').val(bagWidth + ' x ' + bagHeight);
      }
    });

    _defineProperty(_assertThisInitialized(_this4), "CalcWeight", function () {
      var width = parseFloat($('#wei_width').val());
      var height = parseFloat($('#wei_height').val());
      var thickness = parseFloat($('#wei_thick').val());

      if (isNaN(height) || isNaN(width)) {
        $('#wei_result').val(translate('Unknown', 'Inconnue'));
      } else {
        $('#wei_result').val(width * height / 15 * thickness / 1000);
      }
    });

    _defineProperty(_assertThisInitialized(_this4), "ConvertUmTh", function () {
      var micron = parseFloat($('#conv_um_th_val').val());

      if (isNaN(micron)) {
        $('#conv_um_th_result').val(translate('Unknown', 'Inconnue'));
      } else {
        $('#conv_um_th_result').val(Math.round(micron / 25.4 * 100) / 100);
      }
    });

    _defineProperty(_assertThisInitialized(_this4), "ConvertThUm", function () {
      var mil = parseFloat($('#conv_th_um_val').val());

      if (isNaN(mil)) {
        $('#conv_th_um_result').val(translate('Unknown', 'Inconnue'));
      } else {
        $('#conv_th_um_result').val(Math.round(mil * 25.4 * 100) / 100);
      }
    });

    return _this4;
  }

  _createClass(Content, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("h1", null, this.props.currentName)), this.props.currentTab === 1 ? /*#__PURE__*/React.createElement("div", {
        className: "modal-body "
      }, /*#__PURE__*/React.createElement("div", {
        className: "first-line"
      }, /*#__PURE__*/React.createElement("img", {
        className: "logo first",
        src: this.props.getRoundBin(),
        alt: ""
      }), /*#__PURE__*/React.createElement("div", {
        className: "content-container"
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, translate('For a cylindrical trash bin', 'Pour une poubelle cylindrique')), /*#__PURE__*/React.createElement("div", {
        className: "d-flex flex-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "input-boxes"
      }, /*#__PURE__*/React.createElement("div", {
        className: "input-box"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, translate('Diameter', 'Diamètre')), /*#__PURE__*/React.createElement("span", null, "(PO.)")), /*#__PURE__*/React.createElement("input", {
        type: "text",
        id: "circ_diameter"
      })), /*#__PURE__*/React.createElement("div", {
        className: "input-box"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, translate('Height', 'Hauteur')), /*#__PURE__*/React.createElement("span", null, "(PO.)")), /*#__PURE__*/React.createElement("input", {
        type: "text",
        id: "circ_height"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "result-box"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-dark",
        onClick: this.CalcCirc
      }, translate('Generate size', 'Générer une taille')), /*#__PURE__*/React.createElement("input", {
        className: "result",
        type: "text",
        id: "circ_result"
      }), /*#__PURE__*/React.createElement("span", null, "PO."))))), /*#__PURE__*/React.createElement("div", {
        className: "second-line"
      }, /*#__PURE__*/React.createElement("img", {
        className: "logo first",
        src: this.props.getRectBin(),
        alt: ""
      }), /*#__PURE__*/React.createElement("div", {
        className: "content-container"
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, translate('For a rectangular trash bin', 'Pour une poubelle rectangulaire')), /*#__PURE__*/React.createElement("div", {
        className: "d-flex flex-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "input-boxes"
      }, /*#__PURE__*/React.createElement("div", {
        className: "input-box"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, translate('Side 1', 'Côté 1')), /*#__PURE__*/React.createElement("span", null, "(PO.)")), /*#__PURE__*/React.createElement("input", {
        type: "text",
        id: "rect_width_side_1"
      })), /*#__PURE__*/React.createElement("div", {
        className: "input-box"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, translate('Side 2', 'Côté 2')), /*#__PURE__*/React.createElement("span", null, "(PO.)")), /*#__PURE__*/React.createElement("input", {
        type: "text",
        id: "rect_width_side_2"
      })), /*#__PURE__*/React.createElement("div", {
        className: "input-box"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, translate('Height', 'Hauteur')), /*#__PURE__*/React.createElement("span", null, "(PO.)")), /*#__PURE__*/React.createElement("input", {
        type: "text",
        id: "rect_height"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "result-box"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-dark",
        onClick: this.CalcRect
      }, translate('Generate size', 'Générer une taille')), /*#__PURE__*/React.createElement("input", {
        className: "result",
        type: "text",
        id: "rect_result"
      }), /*#__PURE__*/React.createElement("span", null, "PO.")))))) : null, this.props.currentTab === 2 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/React.createElement("div", {
        className: "first-line"
      }, /*#__PURE__*/React.createElement("div", {
        className: "content-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "d-flex flex-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "input-boxes"
      }, /*#__PURE__*/React.createElement("div", {
        className: "input-box first"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, translate('Diameter', 'Diamètre')), /*#__PURE__*/React.createElement("span", null, "(PO.)")), /*#__PURE__*/React.createElement("input", {
        type: "text",
        id: "wei_width"
      })), /*#__PURE__*/React.createElement("div", {
        className: "input-box"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, translate('Height', 'Hauteur')), /*#__PURE__*/React.createElement("span", null, "(PO.)")), /*#__PURE__*/React.createElement("input", {
        type: "text",
        id: "wei_height"
      })), /*#__PURE__*/React.createElement("div", {
        className: "input-box"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, translate('Thickness', 'Epaisseur')), /*#__PURE__*/React.createElement("span", null, "(PO.)")), /*#__PURE__*/React.createElement("input", {
        type: "text",
        id: "wei_thick"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "result-box"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-dark",
        onClick: this.CalcWeight
      }, translate('Calculate weight', 'Calculer poids')), /*#__PURE__*/React.createElement("input", {
        className: "result",
        type: "text",
        id: "wei_result"
      }), /*#__PURE__*/React.createElement("span", null, "LBS."))))))) : null, this.props.currentTab === 3 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/React.createElement("div", {
        className: "first-line"
      }, /*#__PURE__*/React.createElement("div", {
        className: "content-container first"
      }, /*#__PURE__*/React.createElement("span", null, translate('Micrometer to Mil', 'Micromètre à Mil')), /*#__PURE__*/React.createElement("div", {
        className: "d-flex flex-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "input-boxes"
      }, /*#__PURE__*/React.createElement("div", {
        className: "input-box"
      }, /*#__PURE__*/React.createElement("span", null, translate('Micrometer', 'Micromètre')), /*#__PURE__*/React.createElement("input", {
        type: "text",
        id: "conv_um_th_val"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "result-box"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-dark",
        onClick: this.ConvertUmTh
      }, translate('Convert', 'Convertir')), /*#__PURE__*/React.createElement("input", {
        className: "result",
        type: "text",
        id: "conv_um_th_result"
      }), /*#__PURE__*/React.createElement("span", null, "MILS"))))), /*#__PURE__*/React.createElement("div", {
        className: "second-line"
      }, /*#__PURE__*/React.createElement("div", {
        className: "content-container first"
      }, /*#__PURE__*/React.createElement("span", null, translate('Mil to Micrometer', 'Mil à Micromètre')), /*#__PURE__*/React.createElement("div", {
        className: "d-flex flex-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "input-boxes"
      }, /*#__PURE__*/React.createElement("div", {
        className: "input-box"
      }, /*#__PURE__*/React.createElement("span", null, translate('Mils', 'Mils')), /*#__PURE__*/React.createElement("input", {
        type: "text",
        id: "conv_th_um_val"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "result-box"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-dark",
        onClick: this.ConvertThUm
      }, translate('Convert', 'Convertir')), /*#__PURE__*/React.createElement("input", {
        className: "result",
        type: "text",
        id: "conv_th_um_result"
      }), /*#__PURE__*/React.createElement("span", null, translate('Micrometer', 'Micromètre').toUpperCase()))))))) : null);
    }
  }]);

  return Content;
}(Component);

var CalculatorModal = /*#__PURE__*/function (_Component4) {
  _inherits(CalculatorModal, _Component4);

  var _super4 = _createSuper(CalculatorModal);

  function CalculatorModal(props) {
    var _this5;

    _classCallCheck(this, CalculatorModal);

    _this5 = _super4.call(this, props);

    _defineProperty(_assertThisInitialized(_this5), "changeTab", function (tab) {
      _this5.setState({
        currentTab: tab.id,
        currentName: tab.name
      });
    });

    _defineProperty(_assertThisInitialized(_this5), "getRoundBin", function () {
      return document.querySelector('#shop-page').getAttribute('round-bin');
    });

    _defineProperty(_assertThisInitialized(_this5), "getRectBin", function () {
      return document.querySelector('#shop-page').getAttribute('rect-bin');
    });

    _this5.state = {
      currentTab: 1,
      currentName: translate('Dimensions calculator', 'Calculateur de dimensions'),
      tabList: [{
        id: 1,
        name: translate('Dimensions calculator', 'Calculateur de dimensions')
      }, {
        id: 2,
        name: translate('Weight calculator', 'Calculateur de poids')
      }, {
        id: 3,
        name: translate('Thickness converter', "Convertisseur d'épaisseur")
      }]
    };
    return _this5;
  }

  _createClass(CalculatorModal, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "calculator-modal"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "CalculatorModal",
        tabIndex: "-1",
        role: "dialog",
        "aria-labelledby": "exampleModalCenterTitle",
        "aria-hidden": "true",
        "data-backdrop": "false"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-dialog-centered",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Tabs, {
        currentTab: this.state.currentTab,
        tabList: this.state.tabList,
        changeTab: this.changeTab
      })), /*#__PURE__*/React.createElement(Content, {
        getRoundBin: this.getRoundBin,
        getRectBin: this.getRectBin,
        currentTab: this.state.currentTab,
        currentName: this.state.currentName
      })))));
    }
  }]);

  return CalculatorModal;
}(Component);

CalculatorModal.propTypes = {
  handleClick: PropTypes.func,
  currentTab: PropTypes.number
};
Tab.propTypes = {
  handleClick: PropTypes.func,
  isCurrent: PropTypes.bool,
  name: PropTypes.string,
  currentTab: PropTypes.number
};
Tabs.propTypes = {
  changeTab: PropTypes.func,
  currentTab: PropTypes.number,
  tabList: PropTypes.array
};
Content.propTypes = {
  tabList: PropTypes.array,
  currentTab: PropTypes.number,
  currentName: PropTypes.string,
  getRectBin: PropTypes.func,
  getRoundBin: PropTypes.func
};
export default CalculatorModal;